import { Injectable } from '@angular/core';
import { ApiService, BaseApiService } from '@fc-core/services/base-api.service';
import { Harness, HarnessType } from '@fc-core/models';
import { expand, map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@ApiService({
  baseName: 'harness',
})
export class HarnessApiService extends BaseApiService {
  static harnessIconDictionary = {
    [HarnessType.OBD2YCable]: 'assets/icons/harness/obd-2.svg',
    [HarnessType.OBD2Cable]: 'assets/icons/harness/obd-2.svg',
    [HarnessType.J1939Cable]: 'assets/icons/harness/j-1939.svg',
    [HarnessType.J1939YCable]: 'assets/icons/harness/j-1939.svg',
    [HarnessType.J1708Cable]: 'assets/icons/harness/j-1708.svg',
    [HarnessType.J1708YCable]: 'assets/icons/harness/j-1708.svg',
    [HarnessType.Wire3]: 'assets/icons/harness/3-wire.svg',
  };

  constructor(private http: HttpClient) {
    super();
  }

  static fromJSON(res: any): Harness {
    return res;
  }

  getHarnessIcon(type: HarnessType): string {
    return HarnessApiService.harnessIconDictionary[type];
  }

  // TODO: replace hand-rolled pagination loop with fetchAllPages (@fc-shared/utils/request-utils/fetch-all-pages)
  loadAll(): Observable<Harness[]> {
    return this.http.get(this.getUrl()).pipe(
      expand((results: any) => {
        if (!!results['next']) {
          return this.http.get(results['next']);
        } else {
          return EMPTY;
        }
      }),
      map((res: any) => res['results']),
      map((res): Harness[] => {
        return res.map((harnesses: any) =>
          HarnessApiService.fromJSON(harnesses),
        );
      }),
    );
  }

  load(id: number): Observable<Harness> {
    return this.http.get<Harness>(this.getUrl(id)).pipe(
      map((res: Harness): Harness => {
        return HarnessApiService.fromJSON(res);
      }),
    );
  }

  search(
    search: string,
    assigned: boolean,
    device?: number,
    vehicleId?: number,
  ): Observable<Harness[]> {
    let params: HttpParams = new HttpParams()
      .set('search', search)
      .set('assigned', assigned ? 'true' : 'false')
      .set('ordering', 'serial');

    if (device) {
      params = params.set('device', device + '');
    }

    if (vehicleId) {
      params = params.set('vehicle_id', vehicleId + '');
    }

    return this.http.get(this.getUrl(), { params: params }).pipe(
      map((res: any) => res['results']),
      map((res: Harness[]): Harness[] => {
        return res.map((hw) => HarnessApiService.fromJSON(hw));
      }),
    );
  }

  validateHarness(serial: string, vehicleId?: number): Observable<Harness> {
    let params: HttpParams = new HttpParams();
    if (vehicleId) params = params.append('vehicle_id', vehicleId);
    return this.http.get<Harness>(this.getUrl() + `s/${serial}/validate/`, {
      params,
    });
  }
}
